import React from 'react';
import Kudumbasree from './Kudumbasree';

const Students = () => <Kudumbasree campaignType="students" />;

export default Students;
